import React, { useEffect, useState } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { useTranslation } from 'react-i18next';
import { Row, Col } from "reactstrap";
import 'filepond/dist/filepond.min.css';
import 'filepond/dist/filepond.min.css';
import { Steps } from 'antd';
import { createRole, updateRole } from "../services/roleApi";
const { Step } = Steps;

const AddEditRoleForm = ({ modal, setModal, toggle, selectedRole }) => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Mais il te faut un nom pour créer un role"),
    description: Yup.string().required("Merci de mettre la description"),
  });

  const initialValues = selectedRole ? {
    name: selectedRole.name,
    description: selectedRole.description,
  } : {
    name: "",
    description: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        
        if (selectedRole) {
          await updateRole(selectedRole?.id, {...values});
          toast.success("Le role a été modifié avec succès 🎉");
        } else {
          await createRole({...values});
          toast.success("Le role a été créé avec succès 🎉");
        }

        await queryClient.invalidateQueries("roles");
        toggle();
        formik.resetForm();
      } catch (error) {
        toast.error(`😌 Erreur: ${error?.message || error}`);
      } finally {
        setIsLoading(false);
      }
    },
  });


  
  
 
  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedRole]);

  const modalTitle = selectedRole ? t("createEditRole.modalTitleEdit") : t("createEditRole.modalTitleAdd");
 
  
  return (
    <div className="" style={{ borderRadius: '8px' }}>
    <Modal
    id="showModalClient"
    isOpen={modal}
    toggle={toggle}
    centered
    backdrop={"static"}
    style={{
      maxWidth: "440px",
      maxHeight: "593px",      

    }}
  > 

<Row>

</Row>
<Form onSubmit={formik.handleSubmit}>
  <ModalBody className="modal-body">
  <div className="text-center"style={{color:'#252525',fontFamily:'Raleway',fontSize:'22px',fontWeight:'bold'}}> 
  {modalTitle} 

  </div>
  <Row className="">
    <Col md={12}>
      <div className="">
      <label htmlFor="name" className="form-label"> Nom <span className="text-danger">*</span> </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Veuillez renseigner le nom du role à créer"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  required
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="text-danger">{formik.errors.name}</div>
                )}

      </div>
    </Col>
  </Row>
  

  <Row className="justify-content-center">
    <Col md={12}>
      <div className="mb-3">
        <label htmlFor="description" className="form-label" style={{color:'#6C6B6B',fontFamily:'Inter',fontWeight:'400px',size:'14px'}}>{t("types.description")}</label>
        <textarea
          id="description"
          name="description"
          className="form-control"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.description}
          rows="4"
          style={{
            border: '1px solid #D9D9D9'
          }}
        />
        {formik.touched.description && formik.errors.description && (
          <div className="text-danger">{formik.errors.description}</div>
        )}
      </div>
    </Col>
  </Row>
  
  <div className=" center ">
            
            <Button type="submit" className="bordered-btn" disabled={isLoading}>
            {isLoading ? <Spin size="small" /> : selectedRole ? t("rappels.edit") : t("rappels.add")}
            </Button>
            <Button className="bordered-btn-light" color="light" onClick={() => setModal(false)}>
              {t("driverForm.cancel")}
            </Button>
            </div>
  </ModalBody>


</Form>

  </Modal>
  </div>
  );
};
export default AddEditRoleForm;

